export default __webpack_public_path__ + "static/Screenshot6-e2e4fd32d6bcef244af688c2992adb95.jpg";